require('./modifyChoreStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;

//@ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');
const dateHelper = require('utilities/dateHelper');

// @ constants
const { DATE_FORMAT_ES } = require('constants/index');

class ModifyChoreStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.modifyList = this.modifyList.bind(this);
    }

    modifyList(list){
        return list.map((data, index) => {
            if(data.key || data.defaultShow){
                return(
                    <OKInformativeListItem
                        className={"modify-chore-step-two__list-item"}
                        bodyText={data.key || '-'}
                        key={index}
                        title={data.title}
                        bodyWordBreak={false}
                    />
                );
            }
        });
    }

    render() {
        const { immOpenYoungCardModifyChore, immChoreDetails, immCard } = this.props;
        const chore = formatText(`openYoungCardChores-task${immChoreDetails.getIn(['chore','choreId'])}`);
        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const amount = [
            getFormattedString({ amount: immOpenYoungCardModifyChore.get('amount'), currency })
        ];
        const selectedEndDate =  dateHelper.buildFormattedDate(
            immOpenYoungCardModifyChore.get('selectedEndDate'),
            DATE_FORMAT_ES
        );

        const concept = immOpenYoungCardModifyChore.get('concept');
        const selectedRepetitionType = immChoreDetails.get('repeatTask') || formatText('modifyChoreStep-noRepetitions');
        const list = [
            {
                key: chore,
                title: formatText('modifyChoreStep-chore')
            },
            {
                key: amount,
                title: formatText('modifyChoreStep-amount')
            },
            {
                key: selectedEndDate,
                title: formatText('modifyChoreStep-selectedEndDate')
            },
            {
                key: selectedRepetitionType,
                title: formatText('modifyChoreStep-repetitions')
            },
            {
                key: concept && concept.trim(),
                title: formatText('modifyChoreStep-concept'),
                defaultShow: true
            }
        ];
        return (
            <section className="modify-chore-step-two row">
                <header className="modify-chore-step-two__header">
                    <FormattedText value="modifyChoreStep2-title" className="modify-chore-step-two__title" />
                    <FormattedText value="modifyChoreStep2-subTitle" className="modify-chore-step-two__sub-title" />
                </header>
                <OKInformativeList columns={2}>
                    {this.modifyList(list)}
                </OKInformativeList>
            </section>
        )
    }
}

ModifyChoreStep2.propTypes = {
    immCard: PropTypes.object.isRequired,
    immOpenYoungCardModifyChore: PropTypes.object.isRequired,
    immChoreDetails: PropTypes.object.isRequired
};

module.exports = ModifyChoreStep2;
